import React from "react";
import { cn } from "../../lib/utils";

export const AddDashedButton = ({
  onClick,
  children,
  dataCy,
  tone = "line",
  className,
}: {
  onClick?: () => void;
  children: React.ReactNode;
  dataCy?: string;
  tone?: "line" | "gold";
  className?: string;
}) => (
  <button
    type="button"
    data-cy={dataCy}
    onClick={onClick}
    className={cn(
      "flex h-10 w-full items-center justify-center gap-2 rounded-card border border-dashed bg-surface-card text-sm text-ink-muted hover:bg-surface hover:text-ink",
      tone === "gold" ? "border-gold" : "border-line",
      className,
    )}
  >
    {children}
  </button>
);
